var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cr-wrapper"},[_c('call-test-list',{attrs:{"data":_vm.items,"server-ip":_vm.dataParams.ip,"server-port":_vm.dataParams.serverport}}),_c('call-test-dialog',{ref:"callTestDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }